import { Component, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { IStatusPanelParams } from 'ag-grid-community'
@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
  selector: 'app-custom-pagination',
  templateUrl: './custom-pagination.component.html',
  styleUrls: ['./custom-pagination.component.scss']
})
export class CustomPaginationComponent implements OnDestroy {
  private params;
  pageSize = 25;
  pageSizes;
  currentPage: number = 0;
  totalPages: number = 1;
  totalRowsCount: number = 0;
  currentPageMaxCount: number = 0;

  private readonly onPaginationChanged = () => this.paginationChanged();

  agInit(params: IStatusPanelParams): void {
    this.params = params;
    if (this.params.pageSizes) {
      this.pageSizes = this.params.pageSizes;
    }
    if (this.params.pageSize) {
      this.pageSize = this.params.pageSize;
      params.api.setGridOption('paginationPageSize', Number(this.pageSize));
    }

    // ag-grid ignores gridOptions mutated after the grid is created, so subscribe on the api.
    params.api.addEventListener('paginationChanged', this.onPaginationChanged);
    this.paginationChanged();
  }

  ngOnDestroy(): void {
    if (this.params?.api && !this.params.api.isDestroyed?.()) {
      this.params.api.removeEventListener('paginationChanged', this.onPaginationChanged);
    }
  }

  paginationChanged() {
    this.currentPage = this.params.api.paginationGetCurrentPage() + 1;
    this.totalPages = this.params.api.paginationGetTotalPages() ? this.params.api.paginationGetTotalPages() : 1;
    this.totalRowsCount = this.params.api.paginationGetRowCount();
    this.currentPageMaxCount = this.currentPage === this.totalPages ? this.params.api.paginationGetRowCount() : this.pageSize * this.currentPage;
  }

  goToFirstPage() {
    this.params.api.paginationGoToFirstPage();
  }

  goToNextPage() {
    this.params.api.paginationGoToNextPage();
  }

  goToPreviousPage() {
    this.params.api.paginationGoToPreviousPage();
  }

  goToLastPage() {
    this.params.api.paginationGoToLastPage();
  }

  pageSizeChanged() {
    this.pageSize = Number(this.pageSize);
    this.params.api.setGridOption('paginationPageSize', this.pageSize);
    if (this.params.actionName) {
      this.params.context.componentParent[this.params.actionName](this.pageSize);
    }
  }

}
